var map = {
	"./Book": 4,
	"./Book.svg": 4,
	"./Book2": 5,
	"./Book2.svg": 5,
	"./CameraVideoFill": 6,
	"./CameraVideoFill.svg": 6,
	"./CheckSquareFil-black": 7,
	"./CheckSquareFil-black.svg": 7,
	"./CheckSquareFil-info": 8,
	"./CheckSquareFil-info.svg": 8,
	"./CheckSquareFill-primary": 9,
	"./CheckSquareFill-primary.svg": 9,
	"./CheckSquareFill-secondary": 10,
	"./CheckSquareFill-secondary.svg": 10,
	"./DonwloadRedacao": 11,
	"./DonwloadRedacao.svg": 11,
	"./FileTextFill": 12,
	"./FileTextFill.svg": 12,
	"./GraphUp": 13,
	"./GraphUp.svg": 13,
	"./LockFill": 14,
	"./LockFill.svg": 14,
	"./VolumeUpFill": 15,
	"./VolumeUpFill.svg": 15,
	"./anos_finais": 16,
	"./anos_finais.svg": 16,
	"./anos_iniciais": 17,
	"./anos_iniciais.svg": 17,
	"./arrow-left": 18,
	"./arrow-left.svg": 18,
	"./arrow-right": 19,
	"./arrow-right-circle": 20,
	"./arrow-right-circle.svg": 20,
	"./arrow-right.svg": 19,
	"./arrow-select": 21,
	"./arrow-select.svg": 21,
	"./back": 22,
	"./back.svg": 22,
	"./camera": 23,
	"./camera.svg": 23,
	"./ckeck": 24,
	"./ckeck.svg": 24,
	"./coroa-finish": 25,
	"./coroa-finish.svg": 25,
	"./exclamation": 26,
	"./exclamation.svg": 26,
	"./infantil": 27,
	"./infantil.svg": 27,
	"./linguagens-sign": 28,
	"./linguagens-sign.svg": 28,
	"./link-ia": 29,
	"./link-ia.svg": 29,
	"./logo": 30,
	"./logo-edukai": 31,
	"./logo-edukai.svg": 31,
	"./logo-maxia": 32,
	"./logo-maxia-symbol": 33,
	"./logo-maxia-symbol.svg": 33,
	"./logo-maxia.svg": 32,
	"./logo-topo-fixo": 34,
	"./logo-topo-fixo.svg": 34,
	"./logo.svg": 30,
	"./logo_02": 35,
	"./logo_02.svg": 35,
	"./logotipo-maxia": 36,
	"./logotipo-maxia.svg": 36,
	"./medio": 37,
	"./medio-blocked": 38,
	"./medio-blocked.svg": 38,
	"./medio.svg": 37,
	"./mini-check": 39,
	"./mini-check.svg": 39,
	"./nav-volta-azul": 40,
	"./nav-volta-azul.svg": 40,
	"./nav-voltar": 41,
	"./nav-voltar.svg": 41,
	"./next": 42,
	"./next.svg": 42,
	"./patch-question": 43,
	"./patch-question-fill": 44,
	"./patch-question-fill.svg": 44,
	"./patch-question.svg": 43,
	"./poposta": 45,
	"./poposta.svg": 45,
	"./turno-manha": 46,
	"./turno-manha.svg": 46,
	"./turno-tarde": 47,
	"./turno-tarde.svg": 47
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1683;